import { render } from "./DefaultFileInput.vue?vue&type=template&id=33fa25e6&scoped=true"
import script from "./DefaultFileInput.vue?vue&type=script&lang=js"
export * from "./DefaultFileInput.vue?vue&type=script&lang=js"

import "./DefaultFileInput.vue?vue&type=style&index=0&id=33fa25e6&scoped=true&lang=css"
import "./DefaultFileInput.vue?vue&type=style&index=1&id=33fa25e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fa25e6"]])

export default __exports__